import { createFileRoute } from "@tanstack/react-router";
import { MulticastVsOttPage } from "@/components/guides/MulticastVsOttPage";
import { multicastVsOttSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/guides/multicast-iptv-vs-ott")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) =>
    multicastVsOttSeo(loaderData?.href ?? "/guides/multicast-iptv-vs-ott"),
  component: MulticastVsOttPage,
});
